import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'customer-simple-button',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
  ],
  template: `
  <button
    class="custom-mat-button-{{ type }}"
    mat-button
    [disabled]="disabled"
    (click)="action && action()">
    {{ label }}
  </button>`,
  styleUrls: ['./simple-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleButtonComponent {
  @Input() action: any;
  @Input() disabled = false;
  @Input() label = 'submit';
  @Input() type: 'primary' | 'secondary' | 'warning' | 'success' = 'primary';

  constructor() { }
}
